import Vue from 'vue'
import App from './App.vue'
import Vuex from 'vuex'
import store from './store/index'
import vuetify from './plugins/vuetify'
import router from './router/index'
import '@mdi/font/css/materialdesignicons.css'

import VueObserveVisibility from 'vue-observe-visibility'
import VueYandexMetrika from 'vue-yandex-metrika'

import './style/color.css'
import './style/common.css'
import './style/text.css'
import './style/animations.css'
import './style/mobile.css'
import './style/tablet.css'
import './style/computer.css'

import globalUIParameters from './mixins/global-ui-parameters'

Vue.use(Vuex)
Vue.use(VueObserveVisibility)
Vue.mixin(globalUIParameters)

Vue.use(VueYandexMetrika, {
    id: 108285230,
    router: router,
    env: process.env.NODE_ENV,
    options: {
        clickmap: true,
        trackLinks: true,
        accurateTrackBounce: true,
        webvisor: true
    }
})

Vue.config.productionTip = false

new Vue({
    store,
    vuetify,
    router,
    render: h => h(App),
    mounted() {
        const preloader = document.getElementById('preloader')
        if (preloader) {
            preloader.classList.add('fade-out')
            setTimeout(() => preloader.remove(), 700)
        }
    }
}).$mount('#app')
